// CertCardPrintModal 전용 — 값 길이에 맞춰 폰트를 줄이는 축소 계산 (SPEC-CHINA-CERT-CARD-PRINT-001).
// 한자(CJK) 1글자는 가로폭이 약 1em, 그 외(영숫자·기호)는 약 0.6em로 보고
// ponytail: 인쇄 글꼴 微软雅黑 굵게(Bold) 실측(2026-10-13)은 숫자 0.62·소문자 0.57·대문자 0.71(W·M 약 1.05)em이라
// 대문자 위주의 긴 값은 칸 끝이 조금 잘릴 수 있다(운영 작업지시서 값 455개 중 0개). 생기면 실제 글자 폭 측정으로 바꾼다.
// 칸이 수용 가능한 em(maxEm)을 넘으면 넘지 않는 선까지 font-size를 줄인다.
// 그래도 넘치면(minScale 바닥) 기존처럼 overflow:hidden + nowrap로 자른다.

// 전각(full-width) 문자 코드포인트 범위 — CJK 통합한자·한글·가나 등
const FULL_WIDTH_RANGES = [
  [0x1100, 0x115f],
  [0x2e80, 0x303e],
  [0x3041, 0x33ff],
  [0x3400, 0x4dbf],
  [0x4e00, 0x9fff],
  [0xa960, 0xa97f],
  [0xac00, 0xd7a3],
  [0xf900, 0xfaff],
  [0xfe30, 0xfe4f],
  [0xff00, 0xff60],
  [0xffe0, 0xffe6],
  [0x20000, 0x3fffd],
];

function isFullWidth(codePoint) {
  return FULL_WIDTH_RANGES.some(([start, end]) => codePoint >= start && codePoint <= end);
}

// 문자열의 대략적인 가로폭을 em 단위로 추정한다 (코드포인트 단위 순회 — 서러게이트 쌍 안전)
export function estimateTextEm(text) {
  if (!text) return 0;
  let em = 0;
  for (const ch of String(text)) {
    em += isFullWidth(ch.codePointAt(0)) ? 1 : 0.6;
  }
  return em;
}

// 칸 수용폭(maxEm)에 맞춘 폰트 축소 비율 — 1을 넘지 않고, minScale 밑으로는 줄이지 않는다
// (그 이상 넘치는 값은 overflow:hidden + nowrap로 자르는 기존 동작에 맡긴다)
export function fitScale(text, maxEm, minScale = 0.6) {
  const w = estimateTextEm(text);
  if (w <= maxEm) return 1;
  return Math.max(minScale, maxEm / w);
}
